<p-card header="Adresat" class="custom-card mt-6">
<div class="w-full flex flex-col gap-2">
  <div class="wide">
    <p-table
      class="announcement-recipients-table"
      (onSort)="onRecipientsSort($event)"
      aria-labelledby="announcement-recipients-label"
      [value]="visibleRecipients()"
      [customSort]="true"
      [rows]="recipientPageSize()"
      [tableStyle]="{ 'min-width': '70rem' }"
      [scrollable]="true"
      sortMode="single"
      [sortField]="recipientSortField()"
      [sortOrder]="recipientSortOrder()"
    >
      <ng-template #caption>
        <span class="sr-only">Lista wybranych adresatów komunikatu.</span>
      </ng-template>
      <ng-template #header>
        <tr>
          <th pSortableColumn="firstName">
            <div class="flex items-center gap-2">
              Imię
              <p-sortIcon field="firstName" />
            </div>
          </th>
          <th pSortableColumn="lastName">
            <div class="flex items-center gap-2">
              Nazwisko
              <p-sortIcon field="lastName" />
            </div>
          </th>
          <th pSortableColumn="email">
            <div class="flex items-center gap-2">
              Adres e-mail
              <p-sortIcon field="email" />
            </div>
          </th>
          <th alignFrozen="right" pFrozenColumn style="width: 5rem">Akcje</th>
        </tr>
      </ng-template>
      <ng-template #body let-recipient>
        <tr>
          <td>{{ recipient.firstName }}</td>
          <td>{{ recipient.lastName }}</td>
          <td>
            <div class="flex flex-col gap-1">
              <span>{{ recipient.email }}</span>
              @if (!recipient.announcementsEmailConsent) {
                <span class="announcement-recipients-consent-warning">
                  Użytkownik nie wyraził zgody na otrzymywanie komunikatów za pomocą środków komunikacji elektronicznej.
                </span>
              }
            </div>
          </td>
          <td alignFrozen="right" pFrozenColumn class="text-right">
            <p-button
              type="button"
              [text]="true"
              [rounded]="true"
              ariaLabel="Usuń adresata"
              pTooltip="Usuń"
              tooltipPosition="top"
              (click)="onRemoveRequested(recipient)"
            >
              <app-icon [name]="'trash'"></app-icon>
            </p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td class="announcement-recipients-empty-label">
            Brak dodanych adresatów
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="narrow">
    <div class="flex flex-col gap-4">
      @for (recipient of visibleRecipients(); track recipient.email) {
        <p-card>
          <div class="flex flex-col gap-3">
            <div class="flex flex-col gap-1">
              <span class="text-sm text-gray-500">Imię</span>
              <span class="font-bold">{{ recipient.firstName }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-sm text-gray-500">Nazwisko</span>
              <span class="font-bold">{{ recipient.lastName }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-sm text-gray-500">Adres e-mail</span>
              <span class="font-bold break-all">{{ recipient.email }}</span>
              @if (!recipient.announcementsEmailConsent) {
                <span class="announcement-recipients-consent-warning">
                  Użytkownik nie wyraził zgody na otrzymywanie komunikatów za pomocą środków komunikacji elektronicznej.
                </span>
              }
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-sm text-gray-500"
                >Data ostatniego logowania</span
              >
              <span class="font-bold">{{
                recipient.lastLoginAt | date: 'yyyy-MM-dd'
              }}</span>
            </div>
            <div class="flex justify-end">
              <p-button
                type="button"
                [text]="true"
                [rounded]="true"
                ariaLabel="Usuń adresata"
                pTooltip="Usuń"
                tooltipPosition="top"
                (click)="onRemoveRequested(recipient)"
              >
                <app-icon [name]="'trash'"></app-icon>
              </p-button>
            </div>
          </div>
        </p-card>
      }
      @if (visibleRecipients().length === 0) {
        <p-card>
          <div class="announcement-recipients-empty-label">
            Brak dodanych adresatów
          </div>
        </p-card>
      }
    </div>
  </div>
  <div
    class="mt-2 flex flex-col gap-4 md:flex-row md:items-center md:justify-between"
  >
    <p-button
      type="button"
      label="Dodaj adresata"
      styleClass="customInfoButton"
      (click)="onAddRequested()"
    ></p-button>
    <p-paginator
      (onPageChange)="onRecipientsPageChange($event)"
      [rows]="recipientPageSize()"
      [first]="recipientPageIndex() * recipientPageSize()"
      [totalRecords]="recipients().length"
      [rowsPerPageOptions]="[5, 10, 20]"
    ></p-paginator>
  </div>
  <div
    appControlError
    [customErrorInput]="control()"
    [isInvalidCondition]="
      control().invalid && (control().dirty || control().touched)
    "
  ></div>
</div>
</p-card>
